import {
  differenceInCalendarDays,
  format as formatDate,
  isValid,
  parseISO,
  startOfDay,
} from 'date-fns';

const CHAT_HISTORY_MS_MIN = 60_000;
const CHAT_HISTORY_MS_HOUR = 60 * CHAT_HISTORY_MS_MIN;

export type ChatHistoryUpdatedAtInput = string | null | undefined;

/**
 * Last-activity label for Kintsugi Advisor **Chat History** list (Dashboard Figma).
 * Examples: `Just now`, `2m ago`, `26min ago`, `1h ago`, `4h ago`, `Yesterday`, `Apr 16 2026`.
 * Pair with `thread.title` from `GET .../chat/threads` for the left column.
 */
export function formatChatHistoryUpdatedAt(iso: ChatHistoryUpdatedAtInput, now: Date = new Date()): string {
  if (typeof iso !== 'string' || iso.trim() === '') {
    return '';
  }

  const then = parseISO(iso.trim());
  if (!isValid(then)) {
    return '';
  }

  const diffMs = now.getTime() - then.getTime();
  if (diffMs < 0) {
    return formatDate(then, 'MMM d yyyy');
  }

  const totalMinutes = Math.floor(diffMs / CHAT_HISTORY_MS_MIN);
  if (totalMinutes < 1) {
    return 'Just now';
  }
  if (totalMinutes < 60) {
    return totalMinutes < 10 ? `${totalMinutes}m ago` : `${totalMinutes}min ago`;
  }

  const totalHours = Math.floor(diffMs / CHAT_HISTORY_MS_HOUR);
  if (totalHours < 24) {
    return `${totalHours}h ago`;
  }

  const calendarDaysBehind = differenceInCalendarDays(startOfDay(now), startOfDay(then));
  if (calendarDaysBehind === 1) {
    return 'Yesterday';
  }

  return formatDate(then, 'MMM d yyyy');
}
